import CommonTable from "@/components/commonTable";
import { calibrateYuanzhiyunRadarRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo, useState } from "react";
import { renderYuanzhiyunCalibrationStatus } from "./status";

interface CalibrateTableYuanzhiyunRadarProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableYuanzhiyunRadar = (props: CalibrateTableYuanzhiyunRadarProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {

        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }

        return _params;
    }, [diagnosisSearchParams, carId]);


    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateYuanzhiyunRadarRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

        const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderYuanzhiyunCalibrationStatus
        },
        {
            title: '后轴到雷达距离(单位：米)',
            dataIndex: 'xOffset'
        },
        {
            title: '雷达中心偏离(左正右负)(单位：米)',
            dataIndex: 'yOffset'
        },
        {
            title: '雷达中心离地高度(单位：米)',
            dataIndex: 'zOffset'
        },
        {
            title: '车辆轴距(单位：米)',
            dataIndex: 'wheelbase'
        }
    ] ;


    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableYuanzhiyunRadar;
